export default "__VITE_ASSET__DxEisVyf__"